import {
  DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME,
  DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME,
  SET_PAYMENT_MESSAGE_FOR_REG_HOME,
  SET_TOURNAMENT_LOADING_FOR_REG_HOME,
  SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME,
  DISPLAY_BIRTH_DATE_MODAL,
  DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL,
  SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT
} from './constants';

export const displayActiveTournaments = activeTournaments => ({
  type: DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME,
  payload: {
    activeTournaments: activeTournaments,
    loadingTournaments: false
  }
});

export const displayMaintenanceMessage = maintenanceMessage => ({
  type: DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME,
  payload: {
    maintenanceMessage: maintenanceMessage 
  }
});

export const setTournamentLoading = () => ({
  type: SET_TOURNAMENT_LOADING_FOR_REG_HOME,
  payload: {
  }
});

export const setPaymentMessage = message => ({
  type: SET_PAYMENT_MESSAGE_FOR_REG_HOME,
  payload: message
});

export const displayBirthDateModal = showModal => ({
  type: DISPLAY_BIRTH_DATE_MODAL,
  payload: showModal
});

export const displayRequiredProfileFieldsModal = showModal => ({
  type: DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL,
  payload: showModal
});

export const setAgeInState = age => ({
  type: SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT,
  payload: age
});

export const setSearchTournamentValue = searchValue => ({
  type: SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME,
  payload: { searchValue: searchValue }
});



// WEBPACK FOOTER //
// ./src/features/registration/home/actionTypes.js